<template>
  <div
    class="w-72 lg2:w-80 lg3:w-98 h-full card-shadow border rounded-md bg-white flex flex-col items-center relative mb-4 cursor-pointer"
    @click="handleCategoryClick(category.category_id_token)"
  >
    <img v-if="category.category_image_url" :src="category.category_image_url"  height="375"/>
    <img v-else :src="require(`@/assets/images/productCategories/${productImage}.png`)"  height="375"/>
    <p class="text-2xl lg2:text-2-8xl pt-5">{{category.category_name}}</p>
    <p class="category-description pl-3 pr-3 pt-2 lg2:text-lg">{{category.category_children}}</p>
  </div>
</template>

<script>
export default {
  props:{
    category:{
      type:Object,
      default:null
    }
  },
  data() {
    return {
      productImages: [
        'PPE',
        'Toys & Games',
        'Arts & Crafts, School & Office',
        'Packaging',
        'Home, Kitchen & Office',
        'Garden & Outdoor',
        'Automotive',
        'Sports & Fitness',
        'Fashion, Textiles & Fabrics',
        'Electronics, Smart Home & Appliances',
        'Baby',
        'Beauty & Personal Care',
        'Computers',
        'Health & Medical',
        'DIY, Tools & Lighting',
        'Industrial & Scientific',
        'Pet Supplies',
        'Travel, Bags & Luggage'
      ]
    }
  },
  computed: {
    productImage() {
      return this.productImages.includes(this.category.category_name) ? this.category.category_name : 'Others'
    }
  },
  methods:{
    handleCategoryClick(id_token) {
      this.$router.push({name:'FreelancerList', query : {category: id_token}})
    },
  }
}
</script>

<style scoped lang="scss">
.card-shadow {
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
}
.category-description {
  line-height: 21.6px;
}
</style>